__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/8d4a8b3f85cf8febbe83fc43a796d5975b0ca7716af73d9c8ff59c0f/";